import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Div from "@jumbo/shared/Div";
import { Button, CircularProgress, Divider, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import { useEffect, useState } from "react";
// import { SearchClarity, SearchColor, SearchLab, SearchPolish, SearchSymmetry, SearchCut } from "../Inventory/polishSinglesearch";
import { a } from "react-spring";
import { Modifier } from "draft-js";
let SearchShape = [{ name: "ROUND" }, { name: "PEAR" }, { name: "MARQUISE" }, { name: "OVAL" }, { name: "EMERALD" }, { name: "RADIANT" }, { name: "PRINCESS" }, { name: "CUSHION" }, { name: "ASSCHER" }, { name: "HEART" }]
export let SearchColor = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'FANCY INTENCE PINK', 'FANCY BROWN', 'BLUE', 'FANCY INTENSE BLUE', 'FANCY INTENCE YELLOW', 'FANCY VIIVD PINK']
export let SearchClarity = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3', 'I1', 'I2', 'I3']
export let SearchLab = ['IGI', 'GIA', 'GSI', 'NO-CERT', 'GCAL','IGI(SH)']
export let SearchPolish = ['ID', 'EX', 'VG', 'GD', 'FR']
export let SearchSymmetry = ['EX', 'VG', 'GD', 'FR', 'G']
export let SearchCut = ['ID', 'EX', 'VG']

const SingleLotupdate = () => {
    const [stone, setStone] = useState('');
    const [params, setParams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [updatedData, setupdatedData] = useState({});
    const [error, setError] = useState(null);
    const { authUser } = useJumboAuth()
    useEffect(async () => {
        await jwtAuthAxios.get('search/parmas?type=single&shape=*').then((res) => {
            setParams(res.data.data);
        });
    }, []);
    const updateddataHandler = (st, key, val) => {
        setupdatedData(prevState => ({
            ...prevState,
            [st]: {
                ...prevState[st], 
                [key]: val
            }
        }));
    };
    const modifierRecordHandler = async () => {
        if (!Object.keys(updatedData).length ) return;
        if (!window.confirm('Are You Sure To Modefiy Inventory Details')) return;
        setLoading(true);
        await jwtAuthAxios.post('stk/inventorydetailupdate', { updatedData,inventoryType:'Single', BRANCH: [authUser?.currentBranch?.FL_BRANCH_CODE] }).then((res) => {
            alert('Record Updated Successfully');
            setupdatedData({});
        }).catch((e) => {
            alert("Internal server Error");
        });
        setLoading(false);
    }
    const stoneSearchHandler = async () => {
        if (!stone) return;
        setLoading(true);
        //    console.log(searchData);

        await jwtAuthAxios
            .post(`search/stone?page=${0}&pageSize=${100000}`, { stoneCert: stone, BRANCH: [authUser?.currentBranch?.FL_BRANCH_CODE] })
            .then((res) => {
                setupdatedData({})
                setData(res?.data?.result);
                // setRowCount(res.data.total);
            })
            .catch((e) => {
                alert("Internal server Error");
            });
        setLoading(false);
    };
    const handleLotchange = async (e) => {
        // if(document.getElementById('all_inv_checkhandler').checked){
            let fname=e.target.name.split('%')[0];
            if(['STATUS','LAB','SHAPE','COLOR','CLARITY','CUT','POLISH','SYMM'].includes(fname)){
            document.querySelectorAll('.row_checkbox:checked').forEach(el => {
                let st = el.getAttribute('data-id');
                if(fname !='STATUS'){
                    document.getElementsByName(`${fname}%${st}`)[0].value=  e.target.value;
                    updateddataHandler(st,fname,e.target.value);
                } else{
                    if(document.getElementsByName(`${fname}%${st}`)[0]?.value == 'AS' || document.getElementsByName(`${fname}%${st}`)[0]?.value == 'A'){
                    document.getElementsByName(`${fname}%${st}`)[0].value=  e.target.value;
                    updateddataHandler(st,fname,e.target.value);
                    }
                }
                });
            }else{                    
                document.getElementsByName(e.target.name)[0].value = e.target.value;
                updateddataHandler(e.target.getAttribute('data-id'),fname,e.target.value);
            }
            }


    const handleAllLotSelect = (e) => {  
        if(e.target.checked){
            document.querySelectorAll('.row_checkbox').forEach(e =>{
                let st = e.getAttribute('data-id');        
                e.checked=true;
                document.querySelectorAll(`[data-id="${st}"]`).forEach((el, index) => {
                    if (index > 0) el.disabled = false;
                });
            })
        }else{
            document.querySelectorAll('.row_checkbox').forEach(e =>{
                let st = e.getAttribute('data-id');        
                e.checked=false;
                document.querySelectorAll(`[data-id="${st}"]`).forEach((el, index) => {
                    if (index > 0) el.disabled = true;
                });
            })
        }
    }
    const handleLotSelect = (e) => {
        let st = e.target.getAttribute('data-id');        
        if(e.target.checked) {
            document.querySelectorAll(`[data-id="${st}"]`).forEach((el, index) => {
                if (index > 0) el.disabled = false;
            });
        } else {
            document.querySelectorAll(`[data-id="${st}"]`).forEach((el, index) => {
                if (index > 0) el.disabled = true;
            });

        }
    }
    function convertToJSON() {
        // Prompt user to paste data
        let inputData = window.prompt("Paste your tabular data (copy from Excel & paste here):");
        
        if (!inputData) {
            alert("No data provided!");
            return;
        }
    
        // Split rows by newline
        let rows = inputData.trim().split("\n");
    
        // Extract headers from the first row
        let headers = rows[0].split("\t");
    
        // Convert remaining rows into JSON objects
        let jsonData = rows.slice(1).map(row => {
            let values = row.split("\t");
            let obj = {};
            headers.forEach((header, index) => {
                obj[header.trim()] = values[index]?.trim() || null; // Assign values to headers
            });
            return obj;
        });
    
        // Output JSON to console
        console.log("Converted JSON:", JSON.stringify(jsonData, null, 2));
        
        // Show in alert (optional)
        alert("Conversion successful! Check the console (F12 > Console).");
        
        return jsonData;
    }
    
    
    
    
    return (
        <Paper sx={{ p: 2, mt: 3 }}>
            <TextField
                label="Stone ID"
                variant="outlined"
                value={stone}
                multiline
                rows={4}
                onChange={(e) => setStone(e.target.value)}
                fullWidth
                margin="normal"
                helperText={`Please ensure to enter the stone certificate number associated with the ${authUser?.currentBranch?.FL_BRANCH_NAME} branch login.`}
            />
            <Stack direction="row" spacing={2} justifyContent={'space-between'}>
            <Button
                variant="contained"
                color="primary"
                onClick={stoneSearchHandler}
                size='large'
                sx={{ px: 6 }}
                disabled={loading}
            >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Search'}
            </Button>
            <div>
            {/* <Button
                variant="contained"
                color="info"
                onClick={convertToJSON}
                size='large'
                sx={{ px: 6,ml:'auto',mr:5 }}
            >
                Paste Data
            </Button> */}
            <Button
                variant="contained"
                color="secondary"
                onClick={modifierRecordHandler}
                size='large'
                sx={{ px: 6,ml:'auto' }}
                // disabled={loading}
            >
                Modify({Object.keys(updatedData).length}) Records
            </Button>
            </div>
            </Stack>
            <Divider sx={{ my: 2 }} />
            <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                <Table size='small' border={1}>
                    <TableHead>
                        <TableRow>
                            {/* {Object?.keys(data[0])?.map((key) => <TableCell>{key}</TableCell>)}
                <TableCell>{key}</TableCell> */}
                            <TableCell><input type="checkbox" id="all_inv_checkhandler" onChange={handleAllLotSelect}/></TableCell>
                            <TableCell>STATUS</TableCell>
                            <TableCell>STONE</TableCell>
                            <TableCell>LAB</TableCell>
                            <TableCell>REPORTNO</TableCell>
                            <TableCell>SHAPE</TableCell>
                            <TableCell>CARATS</TableCell>
                            <TableCell>COLOR</TableCell>
                            <TableCell>CLARITY</TableCell>
                            <TableCell>CUT</TableCell>
                            <TableCell>POLISH</TableCell>
                            <TableCell>SYMM</TableCell>
                            <TableCell>RAP_PRICE</TableCell>
                            <TableCell>FL_TABLE_PER</TableCell>
                            <TableCell>FL_DEPTH_PER</TableCell>
                            <TableCell>MEASUREMENTS</TableCell>
                            <TableCell>RATIO</TableCell>
                            <TableCell>FL_REPORTCOMMENT</TableCell>
                            <TableCell>BRANCH</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) =>
                            <TableRow key={index}>
                                <TableCell><input  type="checkbox" onChange={handleLotSelect} className="row_checkbox" data-index={index} data-id={row['STONE']} name={`CHECK%${row['STONE']}`}/></TableCell>
                                <TableCell>
                                    {(row['STATUS'] == 'A' || row['STATUS'] == 'AS') ?
                                        <select disabled onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`STATUS%${row['STONE']}`} >
                                            <option value="AS" selected={row['STATUS'] == 'AS'}>Arriving Soon</option>
                                            <option value="A" selected={row['STATUS'] == 'A'}>Available</option>
                                        </select> :
                                         row['STATUS']
                                    //     <select disabled data-index={index} data-id={row['STONE']} name={`STATUS%${row['STONE']}`} >
                                    //     <option value={row['STATUS']} selected> {row['STATUS']}</option>
                                    // </select>
                                    }
                                    {/* <select onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`LAB%${row['STONE']}`} >
                                        {SearchLab.map((lab) =><option value={lab} selected={lab==row['LAB']}>{lab}</option>)}
                                    </select>
                                    {row['STATUS']} */}
                                </TableCell>
                                <TableCell>{row['STONE']}</TableCell>
                                <TableCell>
                                    <select disabled onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`LAB%${row['STONE']}`} >
                                        {SearchLab.map((lab) => <option value={lab} selected={lab == row['LAB']}>{lab}</option>)}
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <input disabled type="text" style={{ maxWidth: '100px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`REPORTNO%${row['STONE']}`} defaultValue={row['REPORTNO']} /></TableCell>
                                <TableCell>
                                    <select disabled style={{ maxWidth: '150px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`SHAPE%${row['STONE']}`} >
                                        {[...SearchShape, ...params['SHAPE']].map((shape) => <option value={shape.name} selected={shape.name == row['SHAPE']}>{shape.name}</option>)}
                                    </select></TableCell>
                                <TableCell>{row['CARATS']}</TableCell>
                                <TableCell>
                                    <select disabled style={{ maxWidth: '80px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`COLOR%${row['STONE']}`} >
                                        {SearchColor.map((color) => <option value={color} selected={color == row['COLOR']}>{color}</option>)}
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <select disabled style={{ maxWidth: '80px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`CLARITY%${row['STONE']}`} >
                                        {SearchClarity.map((clarity) => <option value={clarity} selected={clarity == row['CLARITY']}>{clarity}</option>)}
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <select disabled style={{ maxWidth: '80px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`CUT%${row['STONE']}`} >
                                        {[...SearchCut, '-', 'N/A'].map((cut) => <option value={cut} selected={cut == row['CUT']}>{cut}</option>)}
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <select disabled style={{ maxWidth: '80px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`POLISH%${row['STONE']}`} >
                                        {[...SearchPolish, '-', 'N/A'].map((polish) => <option value={polish} selected={polish == row['POLISH']}>{polish}</option>)}
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <select disabled style={{ maxWidth: '80px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`SYMM%${row['STONE']}`} >
                                        {SearchSymmetry.map((symm) => <option value={symm} selected={symm == row['SYMM']}>{symm}</option>)}
                                    </select>
                                </TableCell>
                                <TableCell><input disabled style={{ maxWidth: '80px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`RAP_PRICE%${row['STONE']}`} type="number" defaultValue={row['RAP_PRICE']} /></TableCell>
                                <TableCell><input disabled style={{ maxWidth: '50px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`FL_TABLE_PER%${row['STONE']}`} type="number" defaultValue={row['FL_TABLE_PER']} /></TableCell>
                                <TableCell><input disabled style={{ maxWidth: '50px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`FL_DEPTH_PER%${row['STONE']}`} type="number" defaultValue={row['FL_DEPTH_PER']} /></TableCell>
                                <TableCell><input disabled style={{ maxWidth: '140px' }} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`FL_MEASUREMENTS%${row['STONE']}`} type="text" defaultValue={row['FL_MEASUREMENTS']} /></TableCell>
                                <TableCell><input disabled style={{ maxWidth: '50px' }} max={1} onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`FL_RATIO%${row['STONE']}`} type="number" defaultValue={row['FL_RATIO']} /></TableCell>
                                <TableCell><input disabled style={{ maxWidth: '250px' }}  onChange={handleLotchange} data-index={index} data-id={row['STONE']} name={`FL_REPORTCOMMENT%${row['STONE']}`} type="text" defaultValue={row['FL_REPORTCOMMENT']} /></TableCell>
                                <TableCell>{row['FL_BRID']}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {/* <TableRow>
                 <TableCell>FL_RATIO</TableCell>
                </TableRow> */}
                </Table>
            </TableContainer>
        </Paper>
    )
}
export default SingleLotupdate;